export const knowledgeBankResources = [
  {
    name: "Our Videos (orange televisions)",
    description:
      'All the original Solar Schools video content is located in vintage orange televisions. Click the play button in the box and a window will pop up and play the video. To close it, simply click on the "x" in the top right.',
    imgPath: "/img/ttht/kb-ss-video.jpg",
  },
  {
    name: "External Videos",
    description:
      'Video content produced by external educational authorities is displayed in regular boxes. Click the play button in the box and a window will pop up and play the video. To close it, simply click on the "x" in the top right.',
    imgPath: "/img/ttht/kb-ex-video.jpg",
  },
  {
    name: "Teacher's Toolkit",
    description:
      "To access the Teacher's Toolkit, look to the right side menu. Here you'll find the unit and lesson plans where this particular Knowledge Bank information is taught. Use the links to access those unit and lesson pages.",
    imgPath: "/img/ttht/kb-unit-plans.jpg",
  },
  {
    name: "Page Links",
    description:
      "Orange text with links will take you to different pages in the Knowledge Bank where you'll find relevant information on the specific topic.",
    imgPath: "/img/ttht/kb-link-page.jpg",
  },
  {
    name: "Glossary Links",
    description:
      "Some text in the Knowledge Bank is grey and underlined. By clicking on this text, you will be taken to a page with a definition of that word.",
    imgPath: "/img/ttht/kb-link-glossary.jpg",
  },
  {
    name: "Diagrams",
    description: `You have access to many useful diagrams in the Knowledge Bank. Zoom in by clicking the diagrams. To close them, simply click on the "x" in the top right corner.`,
    imgPath: "/img/ttht/kb-diagrams.jpg",
  },
];



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitHowTo/components/Sections/KnowledgeBankOverview/TTHTKnowledgeBankOverviewSection.consts.js